import React from 'react';
import SectionAIContent from './SectionAIContent';

export default function SectionSurvey(props) {
  return <SectionAIContent {...props} />;
}
